import styled from "styled-components";
import { Result, Button, Typography, Layout } from "antd";
import { HomeOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const StyledLayout = styled(Layout)`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f2f5;
  padding: 16px;
  @media (max-width: 576px) {
    padding: 0;
  }
`;

const StyledContent = styled(Content)`
  padding: 24px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: center;
  width: 100%;
  max-width: 500px;
`;

const StyledTitle = styled(Title)`
  color: #1c8dc9;
  font-size: 24px;

  @media (min-width: 768px) {
    font-size: 28px;
  }
`;

const StyledIcon = styled(LockOutlined)`
  color: #1c8dc9;
  font-size: 48px;

  @media (min-width: 768px) {
    font-size: 72px;
  }
`;

const StyledParagraph = styled(Paragraph)`
  font-size: 14px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const StyledResult = styled(Result)`
  .ant-result-icon {
    margin-bottom: 24px;
  }
  @media (max-width: 576px) {
    padding: 0;
  }

  .ant-result-icon > .anticon {
    font-size: 72px;

    @media (max-width: 576px) {
      font-size: 56px;
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;

  @media (max-width: 575px) {
    flex-direction: column;
  }
`;

const PrimaryButton = styled(Button)`
  background-color: #1c8dc9;
  border-color: #1c8dc9;

  &:hover,
  &:focus {
    background-color: #1a7eb5;
    border-color: #1a7eb5;
  }

  @media (max-width: 575px) {
    width: 100%;
  }
`;

const SecondaryButton = styled(Button)`
  @media (max-width: 575px) {
    width: 100%;
  }
`;

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <StyledLayout>
      <StyledContent>
        <StyledResult
          status="403"
          title={<StyledTitle level={2}>Accès non autorisé</StyledTitle>}
          icon={<StyledIcon />}
          subTitle={
            <StyledParagraph>
              Désolé, vous n'avez pas les autorisations nécessaires pour accéder
              à cette page.
            </StyledParagraph>
          }
          extra={
            <ButtonContainer>
              <PrimaryButton
                type="primary"
                onClick={() => navigate("/")}
                icon={<HomeOutlined />}
              >
                Retour à l'accueil
              </PrimaryButton>
            </ButtonContainer>
          }
        />
      </StyledContent>
    </StyledLayout>
  );
}
